module.exports = "/_next/static/chunks/images/cover-828fcc2984b0fd772bdff483cd8101d1.png";